<template>
  <div class="mx-1">
    <template v-if="matter_id">
      <OldMatterProgram
        :matter_id="matter_id"
        :allows_crud="allows_crud"
        :can_update="can_update"
        :can_delete="can_delete"
      ></OldMatterProgram>
    </template>
    <template v-else> {{ $t("reusable.common.errorOccurred") }} </template>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "OldMatterProgramView",
  components: {
    OldMatterProgram: () => import("./OldMatterProgram"),
  },
  data() {
    return {
      matter_id: Number(this.$route.params.matter_id),
      to_print: false,
    };
  },
  methods: {},
  computed: {
    ...mapGetters({
      user: "getUser",
      matters: names.MATTERS,
    }),
    can_update() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      return false;
    },
    can_delete() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      return false;
    },
    allows_crud() {
      if (
        this.oldMatter &&
        !this.oldMatter.is_closed &&
        (this.can_update || this.can_delete)
      ) {
        const has_permission = this.$hasPermissions("teaching.change_matter");
        if (has_permission) {
          this.$store.commit(names.MUTATE_VISIBILITY_CRUD, true);
          return has_permission;
        } else {
          return false;
        }
      } else {
        this.$store.commit(names.MUTATE_VISIBILITY_CRUD, false);
        return false;
      }
    },
    oldMatter() {
      if (!this.matter_id) return null;
      return this.matters.find((x) => x.id == this.matter_id);
    },
  },
  created() {
    this.$store.dispatch(names.FETCH_MATTER, this.matter_id);
  },
  mounted() {},
};
</script>

<style scoped>
</style>